/* A milestone's own color (Duncan 2026-11-02, from the PM meeting: Johnny wants Substantial Completion to stand out for
   clients). Each milestone can carry one, picked in its window: 8 quick picks or any color; none = Summit's gold. It colors
   the milestone's diamond (Gantt, print) and its type dot in the list -- nothing else. */

// The quick picks. The first is "none": Summit's gold (--type-milestone), which follows light and dark mode.
export const MILESTONE_COLORS = [
  { value: null, label: 'Gold (default)' },
  { value: '#dc2626', label: 'Red' },
  { value: '#ea580c', label: 'Orange' },
  { value: '#16a34a', label: 'Green' },
  { value: '#0d9488', label: 'Teal' },
  { value: '#2563eb', label: 'Blue' },
  { value: '#7c3aed', label: 'Purple' },
  { value: '#db2777', label: 'Pink' },
];

export const isHexColor = (c) => /^#[0-9a-f]{6}$/i.test(String(c || ''));

/** A task's milestone color when it's a milestone with one picked, else the fallback. */
export function milestoneColor(t, fallback = 'var(--type-milestone)') {
  const flag = t && Number(t.milestone_flag ?? t.is_milestone) === 1;
  return flag && isHexColor(t.milestone_color) ? t.milestone_color : fallback;
}
